export default {
  getLoggedUser: ({ loggedUser }) => loggedUser,
  getLoggedIn: ({ loggedIn }) => loggedIn,
};
